import React from 'react';
import surveyData from '../../data/surveyData';
import Box from "@material-ui/core/Box";
import {useStore} from "react-redux";
import TitleBg1 from "../../assets/title_bg_1.svg";
import TitleBg2 from "../../assets/title_bg_2.svg";
import TitleBg3 from "../../assets/title_bg_3.svg";
import TitleBg4 from "../../assets/title_bg_4.svg";
import {useRecoilValue} from "recoil";
import {userState} from "../../state/globalState";


const Title = (props) => {
    const userInfo = useRecoilValue(userState);
    let sentences = surveyData[props.step].questions;
    let title = surveyData[props.step].title;
    title = title.replace('$stdYear$', userInfo.stdYear);

    let titleBg = null;
    if (props.step === 6) {
        titleBg = TitleBg1;
    } else if (props.step === 14) {
        titleBg = TitleBg2;
    } else if (props.step === 17) {
        titleBg = TitleBg3;
    } else if (props.step === 30) {
        titleBg = TitleBg4;
    }else if (props.step === 113) {
        titleBg = TitleBg4;
    }

    const paragraph = sentences.map((sentence, idx) => {

        sentence = sentence.replace('$stdYear$', userInfo.stdYear);

        return (
            <Box m={1} key={idx}>
                <span style={{fontFamily: 'Noto Sans KR', fontStyle: 'normal', fontWeight: 100,
                    color: '#000000', fontSize: '15px'}}>{sentence}</span>
            </Box>
        );
    });

    const category = paragraph.length > 0 ? (
        <div>
            <Box style={{backgroundImage: `url(${titleBg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', padding: '10px 10px', borderRadius: '10px 10px 0 0', margin: '25px 25px 0 25px', boxShadow: 'none'}}>
                <span className='title-bold'>
                    {title}
                </span>
            </Box>
            <div style={{background: 'transparent', border: 'solid 1px #e1e1e1',
                padding: '5px 10px', margin: '0 25px 25px 25px', boxShadow: 'none',
                borderRadius: '0 0 10px 10px'}}>
                {paragraph}
            </div>
        </div>
    ) : (
        <Box style={{backgroundImage: `url(${titleBg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', padding: '10px 10px', borderRadius: '10px', margin: '25px', boxShadow: 'none'}}>
            <span className='title-bold'>
                {title}
            </span>
        </Box>
    );

    return (
        <>
            <br />
            {category}
        </>
    )
};

export default Title;
